import React, { useContext } from "react";
import { TableContainer, Paper } from "@material-ui/core";

import { MatchContext } from "../../context";
import { EQUIPMENT_AVAILABILITY_TABLE_PARAMS } from "../../constants";
import FilledTable from "./components/filled-table.component";
import useStyles from "../tables-container/styles";

export default function EquipmentTable() {
  const { state } = useContext(MatchContext);
  const classes = useStyles();

  return (
    <div className="stockpiles-table" style={{ paddingRight: "1vw" }}>
      <TableContainer
        component={Paper}
        className={!state.hideMatchingTable && classes.container}
      >
        <FilledTable
          stockpilesTableFeatures={EQUIPMENT_AVAILABILITY_TABLE_PARAMS}
        />
      </TableContainer>
    </div>
  );
}
